import React from "react";
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";
import HomeAdCarousel from "./HomeAdCarousel";
import * as adActions from "../redux/actions/adActions";
import * as adListActions from "../redux/actions/adListActions";

function HomeNewAdsCarousel({ adList, loading, SetAd }) {
  return (
    <HomeAdCarousel
      title={<Translate value="home_new_ads_title" />}
      subtitle={<Translate value="home_new_ads_subtitle" />}
      adList={adList}
      loading={loading}
      onAdClick={SetAd}
      seeMoreTo="/home/new"
    />
  );
}

function mapStateToProps(reducer) {
  return {
    adList: adListActions.selectCachedAdList(reducer, adListActions.AD_SOURCES.HOME),
    loading: adListActions.isAdListLoading(reducer, adListActions.AD_SOURCES.HOME),
  };
}

const mapDispatchToProps = (dispatch) => ({
  SetAd: (item) => dispatch(adActions.setAd({ item })),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeNewAdsCarousel);
